
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29.104 29.104","height":"110","width":"110","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#f5f5f5","stroke-width":"7.344","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M5.036 14.552h19.032M14.552 24.068V5.036"}})])])
          )
        }
      }
    